import { IMAGES_BASE_URL, setImageQuality } from '../../../settings';

/**
 * Resolve admin-uploaded iconUrl (absolute URL or CDN key) for img src.
 */
export const resolveSpaceyIconUrl = (iconUrl) => {
  if (!iconUrl || typeof iconUrl !== 'string') {
    return null;
  }
  const trimmed = iconUrl.trim();
  if (!trimmed) {
    return null;
  }
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('/static/') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  return IMAGES_BASE_URL + setImageQuality() + trimmed.replace(/^\//, '');
};

export default resolveSpaceyIconUrl;
